module.exports = __webpack_public_path__ + "static/media/WeChat.66f4ca67.svg";